import { client } from '@trello/graphql';

import { WorkspaceState } from '../workspaceState';

import {
  WorkspaceForCardDocument,
  WorkspaceForCardQueryResult,
  WorkspaceForCardQueryVariables,
} from './WorkspaceForCard.generated';

export async function getWorkspaceStateForCard(
  shortLinkOrId: string,
): Promise<WorkspaceState> {
  const results = await client.query<
    WorkspaceForCardQueryResult['data'],
    WorkspaceForCardQueryVariables
  >({
    query: WorkspaceForCardDocument,
    variables: { shortLinkOrId },
  });
  return {
    status: 'READY',
    error: null,
    isGlobal: false,
    idWorkspace: results?.data?.card?.board?.idOrganization ?? null,
  };
}
